export default "__VITE_ASSET__Cm2l_kJt__"